// extracted by mini-css-extract-plugin
export default {"chatWrapper":"Chat_chatWrapper__9Wys-","selectUserWrapper":"Chat_selectUserWrapper__EbEnT","header":"Chat_header__iwkQN","messagesWrapper":"Chat_messagesWrapper__XzG0A"};